import { render } from "./visita_confirmar.vue?vue&type=template&id=0fbb7064"
import script from "./visita_confirmar.vue?vue&type=script&lang=js"
export * from "./visita_confirmar.vue?vue&type=script&lang=js"

import "./visita_confirmar.vue?vue&type=style&index=0&id=0fbb7064&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__